import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {Page} from '../../models/page.model';
import {PMCModel} from '../../models/pmc.model';
import {PMCItemModel} from '../../models/pmc-item.model';
import {PMCItemResultModel} from "../../models/pmc-item-result.model";

@Injectable({
    providedIn: 'root',
})
export class PMCService {
    private readonly url = environment.apiUrl + '/pmc';

    constructor(private readonly http: HttpClient) {
    }

    getAllPmcs(page = 0, size = 10): Observable<Page<PMCModel>> {
        const params: HttpParams = new HttpParams().set('page', '' + page).set('size', '' + size);
        return this.http.get<Page<PMCModel>>(this.url, {params});
    }

    addPmc(pmc: PMCModel): Observable<PMCModel> {
        return this.http.post<PMCModel>(this.url, pmc);
    }

    findPmcById(id: string): Observable<PMCModel> {
        return this.http.get<PMCModel>(this.url + '/' + id);
    }

    updatePmc(pmc: PMCModel): Observable<PMCModel> {
        return this.http.put<PMCModel>(this.url + '/' + pmc.id, pmc);
    }

    deletePmc(id: string): Observable<PMCModel> {
        return this.http.delete<PMCModel>(this.url + '/' + id);
    }

    savePMCItem(
        pmcItemId: string,
        noInspection: boolean,
        pmcItem: PMCItemResultModel,
        attachment?: File | null,
    ): Observable<PMCItemModel> {
        const formData = new FormData();
        formData.append('pmcItem', new Blob([JSON.stringify(pmcItem)], {type: 'application/json'}));
        if (attachment) {
            formData.append('attachment', attachment, attachment.name);
        }
        return this.http.put<PMCItemModel>(this.url + '/' + pmcItemId + '/item?noInspection=' + noInspection, formData);
    }

    findPMCItemById(id: string): Observable<PMCItemModel> {
        return this.http.get<PMCItemModel>(this.url + '/' + id + '/item/details');
    }

    findAllPMCItems(page = 0, size = 10, startDate?: string, endDate?: string): Observable<Page<PMCItemModel>> {
        let params: HttpParams = new HttpParams().set('page', '' + page).set('size', '' + size);
        if (startDate && endDate) {
            params = params.set('startDate', startDate);
            params = params.set('endDate', endDate);
        }
        return this.http.get<Page<PMCItemModel>>(`${this.url}/items`, {params});
    }

    findAllPMCItemByPMCId(id: string, page = 0, size = 10, goToToday = false): Observable<Page<PMCItemModel>> {
        let params: HttpParams = new HttpParams().set('page', '' + page).set('size', '' + size);
        if (goToToday) {
            params = params.set('goToToday', 'true');
        }
        return this.http.get<Page<PMCItemModel>>(`${this.url}/${id}/items`, {params});
    }

    deletePMCResult(resultId: string): Observable<PMCItemResultModel> {
        return this.http.delete<PMCItemResultModel>(`${this.url}/${resultId}/result`);
    }
}
